// removed by extract-text-webpack-plugin
module.exports = {"container":"Transactions__container__30Gr6","row":"Transactions__row__2ETFG","colLeft":"Transactions__colLeft__3r2hq","colRight":"Transactions__colRight__1UieU","quickPickButton":"Transactions__quickPickButton__2NUAi","loadDataBtn":"Transactions__loadDataBtn__SP-8h","noLeftMargin":"Transactions__noLeftMargin__16zt0","separator":"Transactions__separator__3RJRj","tableContainer":"Transactions__tableContainer__vRgNY"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AdminScreens/Transactions/Transactions.css
// module id = 596
// module chunks = 0